<ion-header>
  <ion-toolbar>
    <p>
      <strong>{{realtrip ? realtrip?.title : 'Paradas'}}</strong>
    </p>
    <ion-buttons slot="primary" *ngIf="realtrips">
      <ion-button (click)="showRealtripsPicker()">
        <ion-icon slot="icon-only" src="/assets/icon/roundtrip-icon.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="!!realtrip && !!stops && realtrip.current_stop_id" class="sell-toolbar">
    <ion-button shape="round" color="primary" expand="block" (click)="confirmShowQR()">Vender boleto</ion-button>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-grid color="light">
    <ion-row color="primary" class="header">
      <ion-col size="5">
        <div>Parada</div>
      </ion-col>
      <ion-col>
        <div>Hora</div>
      </ion-col>
      <ion-col>
        <div>Estatus</div>
      </ion-col>
      <ion-col size="auto">
        <div>Boletos</div>
      </ion-col>
    </ion-row>
    <ng-container *ngIf="loading">
      <ion-row *ngFor="let item of [1,2,3,4,5,6,7,8,9]">
        <ion-col>
          <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ng-container>
    <ion-row *ngIf="!loading && (!stops || stops.length === 0)">
      <ion-col>
        <p>No hay corrida asignada o la corrida no tiene paradas.</p>
      </ion-col>
    </ion-row>
    <ng-container *ngIf="!loading">
      <ion-row *ngFor="let item of stops; let i = index;">
        <ion-col size="5">
          <div>{{item.name}}</div>
        </ion-col>
        <ion-col>
          <div>{{item.starts_at | slice:0:5}}</div>
        </ion-col>
        <ion-col>
          <div *ngIf="currentStopIndex !== null && currentStopIndex >= i">
            <ion-icon name="checkmark"></ion-icon>
          </div>
          <div *ngIf="currentStopIndex === null || currentStopIndex < i">
            <ion-fab-button
              (click)="updateTripStop(item)"
              size="small"
              style="margin: 0 auto"
              [disabled]="!realtrip.active"
            >
              <ion-icon name="checkmark"></ion-icon>
            </ion-fab-button>
          </div>
        </ion-col>
        <ion-col size="auto" class="stop-tickets">
          <div class="wrapper">
            <div class="show-tickets-wrapper">
              <ion-fab-button (click)="showUsers(item)" size="small">
                <ion-icon src="/assets/icon/tickets.svg"></ion-icon>
              </ion-fab-button>
            </div>
            <div class="quantity-wrapper">
              <ion-chip color="primary">{{item.bustickets + item.subscriptions}}</ion-chip>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ng-container>
  </ion-grid>
</ion-content>

<ion-footer class="ion-padding" *ngIf="realtrip">
  <ion-button shape="round" color="success" expand="block" (click)="startTrip()" *ngIf="!realtrip.active">
    Iniciar viaje
  </ion-button>
  <ion-button shape="round" color="warning" expand="block" (click)="endTrip()" *ngIf="realtrip.active">
    Finalizar viaje
  </ion-button>
  <ion-button shape="round" color="primary" expand="block" (click)="scan()" [disabled]="!realtrip.active">
    Escanear subida
  </ion-button>
  <ion-button shape="round" color="secondary" expand="block" (click)="scanExit()" [disabled]="!realtrip.active">
    Escanear bajada
  </ion-button>
</ion-footer>
